import { AfterViewInit, Component, OnDestroy, OnInit, OnChanges, SimpleChange, input, linkedSignal, output, viewChild } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ISimpleListElement } from '../../models/ISimpleListElement';
import { MatCard, MatCardContent, MatCardSubtitle } from '@angular/material/card';
import { MatList, MatListItem, MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { MatLine } from '@angular/material/grid-list';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

// https://www.npmjs.com/package/ngx-mat-select-search
@Component({
    selector: 'lf-multiselect-search',
    templateUrl: './lf-multiselect-search.component.html',
    styleUrls: ['./lf-multiselect-search.component.scss'],
    imports: [MatCard, MatCardContent, MatCardSubtitle, MatList, MatListItem, MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatSelectSearchComponent, MatDivider, MatLine, MatIconButton, MatIcon, AsyncPipe]
})
export class LfMultiselectSearchComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  readonly placeholder = input("");
  readonly placeholderLabel = input("search");
  readonly listElements = input<ISimpleListElement[]>([]);
  readonly selectedElementIds = input<number[]>([]);
  readonly selected = output<number[]>();

  // Zaznaczenie jest stanem wewnętrznym: startuje od inputu, dalej zmienia je użytkownik.
  protected readonly currentElementIds = linkedSignal<number[]>(() => this.selectedElementIds() ?? []);

  public elementCtrl: UntypedFormControl = new UntypedFormControl();

  public elementFilterCtrl: UntypedFormControl = new UntypedFormControl();

  public filteredListElements: ReplaySubject<ISimpleListElement[]> = new ReplaySubject<ISimpleListElement[]>(1);

  public selectedElementsList: ISimpleListElement[] = [];

  readonly singleSelect = viewChild<MatSelect>('singleSelect');

  public placeholderLabelText = "";

  protected _onDestroy = new Subject<void>();

  constructor() { }

  ngOnChanges(changes: Record<string, SimpleChange>) {
    this.rebuildDataList();
  }

  ngOnInit() {

    this.placeholderLabelText = this.placeholderLabel();

    this.elementCtrl.valueChanges.subscribe(
      selectedElement => {
        if (selectedElement) {
          this.currentElementIds.update(ids => [...ids, selectedElement.id]);
          this.rebuildDataList();
          this.elementCtrl.setValue(null);
          this.selected.emit(this.currentElementIds());

        }
      }
    );

    this.elementFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterElements();
      });

    this.rebuildDataList();

  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected rebuildDataList() {
    this.selectedElementsList = [];
    const list: ISimpleListElement[] = [];

    const listElements = this.listElements();
    const selectedElementIds = this.currentElementIds();
    if (listElements) {

      listElements.forEach(element => {
        if (selectedElementIds && selectedElementIds.indexOf(element.id) > -1) {
          this.selectedElementsList.push(element);
        }
        else {
          list.push(element);
        }
      });
    }

    this.filteredListElements.next(list.slice());
  }

  public deleteElement(id: number) {
    this.currentElementIds.update(ids => ids.filter(elementId => elementId !== id));
    this.rebuildDataList();
    this.selected.emit(this.currentElementIds());
  }

  protected setInitialValue() {
    this.filteredListElements
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect().compareWith = (a: ISimpleListElement, b: ISimpleListElement) => a && b && a.id === b.id;
      });
  }

  protected filterElements() {
    const listElements = this.listElements();
    const selectedElementIds = this.currentElementIds();
    if (!listElements) {
      return;
    }

    let search = this.elementFilterCtrl.value;
    if (!search) {
      this.rebuildDataList();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredListElements.next(
      listElements.filter(element => element.name.toLowerCase().indexOf(search) > -1 && selectedElementIds.indexOf(element.id) == -1)
    );
  }

  openedChange(event: any) {

    if (event) {
      this.placeholderLabelText = "";
    }
    else {
      this.placeholderLabelText = this.placeholderLabel();
    }

  }


}
